/** Customer login wizard steps (shared across hooks and UI). */
export enum LoginStep {
	EMAIL,
	TOTP,
	PASSWORD,
	NEW_PASSWORD,
	PASSWORD_FORGOTTEN,
	/** Client vs tiers when both exist (same office). */
	ACTOR_CHOICE,
	/** Several études LIVE for the same email (connexion directe sans lien). */
	CUSTOMER_OFFICE_CHOICE,
	/** Several client × dossier LIVE rows for the same email (or lien / recherche ambiguë). */
	CUSTOMER_TARGET_CHOICE,
}
